import { combineReducers } from 'redux';

import cancelTripReducerMap, {
    cancelTripAction,
} from './actions/cancelTrip';
import changePasswordReducerMap, {
    changePasswordAction,
} from './actions/changePassword';
import checkCancellationReducerMap, {
    checkCancellationAction,
} from './actions/checkCancellation';
import checkReferralCodeMap, {
    checkReferralCodeAction,
} from './actions/checkReferralCode';
import confirmPasswordReducerMap, {
    confirmPasswordAction,
} from './actions/confirmPassword';
import createAccountReducerMap, {
    createAccountAction,
} from './actions/createAccount';
import fetchTicketUrlReducerMap, {
    fetchTicketUrlAction,
} from './actions/fetchTicketUrl';
import fetchTripsReducerMap, {
    fetchTripsAction,
} from './actions/fetchTrips';
import logInReducerMap, {
    logInAction,
} from './actions/logIn';
import logOutReducerMap, {
    logOutAction,
} from './actions/logOut';
import resetPasswordReducerMap, {
    resetPasswordAction,
} from './actions/resetPassword';
import updateBillingAddressReducerMap, {
    updateBillingAddressAction,
} from './actions/updateBillingAddress';
import updateUserNameReducerMap, {
    updateUserNameAction,
} from './actions/updateUserName';
import { formatOrders } from './actions/utils';
import * as purchasedTripSelectors from './appstate/selectors';
import userInfoReducerMap, {
    selectors as userInfoSelectors,
} from './appstate/userInfo';
import namespace from './types';

const reducerMap = {
    ...userInfoReducerMap,

    ...cancelTripReducerMap,
    ...changePasswordReducerMap,
    ...checkCancellationReducerMap,
    ...checkReferralCodeMap,
    ...confirmPasswordReducerMap,
    ...createAccountReducerMap,
    ...fetchTicketUrlReducerMap,
    ...fetchTripsReducerMap,
    ...logInReducerMap,
    ...logOutReducerMap,
    ...resetPasswordReducerMap,
    ...updateBillingAddressReducerMap,
    ...updateUserNameReducerMap,
};

const reducer = combineReducers(reducerMap);

export {
    cancelTripAction,

    changePasswordAction,
    checkCancellationAction,
    checkReferralCodeAction,
    confirmPasswordAction,
    createAccountAction,
    fetchTicketUrlAction,
    fetchTripsAction,
    formatOrders,
    logInAction,
    logOutAction,
    purchasedTripSelectors,
    resetPasswordAction,
    updateBillingAddressAction,
    updateUserNameAction,
    userInfoSelectors,
};

export default {
    [namespace]: reducer,
};
